import React from "react";
import { ShieldCheck, Lock } from "lucide-react";

const TrustBadges = () => (
  <div className="flex items-center justify-center gap-4 mt-6 pt-5 border-t border-gray-100">
    <div className="flex items-center gap-1.5 text-xs text-gray-400">
      <ShieldCheck className="w-3.5 h-3.5 text-green-500" />
      <span>SSL Secured</span>
    </div>
    <div className="w-px h-3 bg-gray-200" />
    <div className="flex items-center gap-1.5 text-xs text-gray-400">
      <Lock className="w-3.5 h-3.5 text-green-500" />
      <span>256-bit Encryption</span>
    </div>
    <div className="w-px h-3 bg-gray-200" />
    <span className="text-xs text-gray-400">Secure Login</span>
  </div>
);

export default TrustBadges;
